

export class BlobPicture
{
    public Image: Blob;
    public PictureTime: Date;
    public IndexFromDevice: number = 0;
    public Size: number = 0;

    constructor(
        image?: Blob,
        creationTime?: Date,
        indexFromDevice?: number,
        size?: number)
    {
        this.Image = image;
        this.PictureTime = creationTime || new Date(0);
        this.IndexFromDevice = indexFromDevice ?? 0;
        this.Size = size ?? 0;
    }
}
